module.exports = __webpack_public_path__ + "img/task1.362a8221.png";